const ATTRIBUTE_TEMPLATE_ENDPOINTS = {
  condition_template: "condition-templates",
  parameter_template: "parameter-templates",
  property_template: "property-templates",
} as const;

const ATTRIBUTE_ENDPOINTS = {
  condition: "conditions",
  parameter: "parameters",
  property: "properties",
} as const;

const OBJECT_TEMPLATE_ENDPOINTS = {
  material_template: "material-templates",
  measurement_template: "measurement-templates",
  process_template: "process-templates",
} as const;

const SPEC_OBJECT_ENDPOINTS = {
  ingredient_spec: "ingredient-specs",
  material_spec: "material-specs",
  measurement_spec: "measurement-specs",
  process_spec: "process-specs",
} as const;

const RUN_OBJECT_ENDPOINTS = {
  ingredient_run: "ingredient-runs",
  material_run: "material-runs",
  measurement_run: "measurement-runs",
  process_run: "process-runs",
} as const;

/**
 * Spec & Run
 */
const DATA_OBJECT_ENDPOINTS = {
  ...RUN_OBJECT_ENDPOINTS,
  ...SPEC_OBJECT_ENDPOINTS,
} as const;

/**
 * Spec & Run & Template (plus "all")
 */
const DATA_OBJECT_OR_TEMPLATE_ENDPOINTS = {
  ...DATA_OBJECT_ENDPOINTS,
  ...OBJECT_TEMPLATE_ENDPOINTS,
  all: "storables",
} as const;

/**
 * Spec & Run & Template & Attributes & Attribute Templates
 */
export const CONCEPT_ENDPOINTS = {
  ...ATTRIBUTE_TEMPLATE_ENDPOINTS,
  ...ATTRIBUTE_ENDPOINTS,
  ...DATA_OBJECT_OR_TEMPLATE_ENDPOINTS,
} as const;
